const STORAGE_PREFIX_RE =
  /^(?:\d+|[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})_/;

/**
 * Strip the storage prefix (`<applicationId>_` / `<timestamp>_` / `<uuid>_`)
 * from a stored file name, keeping extension and underscores. The api's
 * uploadUrl endpoint re-prefixes every requested name, so saving a file in
 * place requires requesting the upload URL with this stripped name — using
 * the stored name verbatim would create a duplicate (`123_123_report.pdf`).
 */
export function storedBaseName(fileName: string): string {
  return fileName.replace(STORAGE_PREFIX_RE, "");
}

/**
 * Strip an optional `<number>_` or UUID prefix from a stored file name and
 * drop the extension + underscores for display. Mirrors the we-pdf helper
 * in `@repo/shared`.
 */
export function displayName(fileName = "Document"): string {
  return storedBaseName(fileName)
    .replace(/\.(?:.{1,5})$/, "")
    .replaceAll("_", " ");
}

/** Truncate a display name to `maxLength` characters, appending an ellipsis. */
export function truncateName(fileName: string, maxLength: number): string {
  if (fileName.length > maxLength) {
    return `${fileName.substring(0, maxLength).trim()}...`;
  }
  return fileName;
}

/** Trigger a browser download of a Blob with the given fileName. */
export function triggerDownload(blob: Blob, fileName: string): void {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(objectUrl);
}
